module.exports = __webpack_public_path__ + "7fe95108e8deb757c168330818e7d0cc.svg";